var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"online-transactions-detail"},[_c('h1',[_vm._v("Transaction Details")]),_c('pre',[_vm._v("      "),_c('code',[_vm._v("\n"+_vm._s(_vm.rawData)+"\n      ")]),_vm._v("\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }